import SVG_LOGO from "../../../../assets/images/vector/Layout/Header/logos/logo_amzscout.svg";
import SVG_LOGO_CN from "../../../../assets/images/vector/Layout/Header/logos/logo_amzscout_cn.svg";
import SVG_FLAG_CN from "../../../../assets/images/vector/Layout/Header/LanguageSwitcher/flag-cn.svg";
import SVG_FLAG_DE from "../../../../assets/images/vector/Layout/Header/LanguageSwitcher/flag-de.svg";
import SVG_FLAG_EN from "../../../../assets/images/vector/Layout/Header/LanguageSwitcher/flag-en.svg";
import SVG_FLAG_FR from "../../../../assets/images/vector/Layout/Header/LanguageSwitcher/flag-fr.svg";
import SVG_FLAG_ES from "../../../../assets/images/vector/Layout/Header/LanguageSwitcher/flag-es.svg";

export const TOOLS_TABS = {
  SITE: "site",
  PARTNERS: "partners",
};

export const ICONS = {
  FREE: "FREE",
  NEW: "NEW",
  UPDATED: "UPDATED",
  HOT: "HOT",
};

export const DROP_MENU_NAMES = {
  tools: "tools",
  videos: "videos",
};
export const URL_LABEL = "r=menu";

export const ANALYTICS_PROPS = {
  category: "MainMenu CTA",
  action: "CTA",
};

export const AVAILABLE_LOGOS = {
  cn: {
    logoPath: `/cn/?${URL_LABEL}`,
    logoSrc: SVG_LOGO_CN,
  },
  de: {
    logoPath: `/de/?${URL_LABEL}`,
    logoSrc: SVG_LOGO,
  },
  en: {
    logoPath: `/?${URL_LABEL}`,
    logoSrc: SVG_LOGO,
  },
  es: {
    logoPath: `/es/?${URL_LABEL}`,
    logoSrc: SVG_LOGO,
  },
  fr: {
    logoPath: `/fr/?${URL_LABEL}`,
    logoSrc: SVG_LOGO,
  },
  ja: {
    logoPath: `/jp/pro/?${URL_LABEL}`,
    logoSrc: SVG_LOGO,
  },
};

export const AVAILABLE_LANGUAGES = {
  cn: {
    flag: SVG_FLAG_CN,
    path: "/cn",
    title: "中文",
  },
  de: {
    flag: SVG_FLAG_DE,
    path: "/de",
    title: "DE",
  },
  en: {
    flag: SVG_FLAG_EN,
    path: "/",
    title: "EN",
  },
  es: {
    flag: SVG_FLAG_ES,
    path: "/es",
    title: "ES",
  },
  fr: {
    flag: SVG_FLAG_FR,
    path: "/fr",
    title: "FR",
  },
  ja: {
    flag: SVG_FLAG_EN,
    path: "/jp/pro",
    title: "日本語",
  },
};

export const ACTIVE_LANGUAGES = ["en", "de", "es", "cn"];

export const CATEGORY_LINKS = {
  PRODUCT_RESEARCH_TOOLS: "PRODUCT RESEARCH TOOLS",
  // KEYWORDS_AND_PRODUCT_LISTING_TOOLS: "Keywords & Product Listing Tools",
  KEYWORDS_AND_LISTING_TOOLS: "KEYWORD & LISTING TOOLS",
  FREE_TOOLS: "FREE TOOLS",
  // QUICK_START_SOLUTIONS: "Quick Start Solutions",
  READY_MADE_SOLUTIONS: "READY-MADE SOLUTIONS",
  LEARN_HOW_TO_SELL_ON_AMAZON: "Learn how to sell on Amazon",
  AMAZON_TRENDS_AND_HOT_PRODUCTS: "Amazon trends and hot products",
};